import { UnknownAction } from "redux";
import { isAccommodationAction } from "../actions/Accommodation.js";
import { Accommodation, AccommodationState, Language } from "../types/index.js";

const initialState: AccommodationState = {};

const getAccommodationSuccess = (
  state: AccommodationState,
  languageId: Language,
  accommodation: Accommodation,
): AccommodationState => {
  return { ...state, [languageId]: accommodation };
};

const reducer = (state = initialState, action: UnknownAction) => {
  if (!isAccommodationAction(action)) {
    return state;
  }

  switch (action.type) {
    case "GET_ACCOMMODATION_SUCCESS":
      return getAccommodationSuccess(
        state,
        action.languageId,
        action.accommodation,
      );

    default:
      return state;
  }
};

export default reducer;
